import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';

export enum CachedRequest {
	CategoryOption = 'categoryoption',
	PipelineTemplate = 'pipelinetemplate'
}

@Injectable({
	providedIn: 'root'
})
export class HttpCacheService {
	private requests: ICachedApi[] = [];
	private readonly cachedUrl: any[] = [
		{ url: 'geo' },
		{ url: 'categoryoption' },
		{ url: 'pipelineemailtemplate' },
		{ url: 'pipelineemailtemplate' },
		{ url: 'pipelinetemplate' },
		{ url: 'profilestatus' },
		{ url: 'resumetemplate' },
		{ url: 'getuserbyrole' }
	];

	put(url: string, response: HttpResponse<any>): void {
		const cachedRequest = {
			url: url,
			httpResponse: response
		};

		if (this.cachedUrl.some((x) => url.toLocaleLowerCase().includes(x.url))) {
			this.requests.push(cachedRequest);
		}
	}

	get(url: string): HttpResponse<any> {
		const cached = this.requests.find((x) => x.url == url);
		if (cached) {
			return cached.httpResponse;
		}

		return new HttpResponse();
	}

	resetSpecializationCategoryOptions(): void {
		this.requests = this.requests.filter(
			(x) => !x.url.toLocaleLowerCase().includes('request=specialization')
		);
	}

	resetTagCategoryOptions(): void {
		this.requests = this.requests.filter(
			(x) => !x.url.toLocaleLowerCase().includes('request=tags')
		);
	}

	resetCampaignCategoryOptions(): void {
		this.requests = this.requests.filter(
			(x) => !x.url.toLocaleLowerCase().includes('request=campaign')
		);
	}

	resetCachedUrl(url: CachedRequest): void {
		this.requests = this.requests.filter(
			(x) => !x.url.toLocaleLowerCase().includes(url)
		);
	}

	public resetCacheByCategoryOption(category: string): void {
		this.requests = this.requests.filter(
			(x) =>
				!x.url
					.toLocaleLowerCase()
					.includes(`request=${category.toLocaleLowerCase()}`)
		);
	}
}

export interface ICachedApi {
	url: string;
	httpResponse: HttpResponse<any>;
}
